import React from 'react';

interface IconVideoProps {
    iconClasses?: string;
}

const IconVideo: React.FC<IconVideoProps> = ({ iconClasses }) => {
    return (
        <svg
            width="20"
            height="16"
            viewBox="0 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-video ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M1.5 2.5A1.5 1.5 0 0 1 3 1h9a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 12 15H3a1.5 1.5 0 0 1-1.5-1.5v-11Z"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
            />
            <path
                d="M13.5 6.2 18 3.5v9l-4.5-2.7V6.2Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};

export default IconVideo;
